import { firebase } from "../helpers/firebase";
import idb from "../helpers/idb";
import coleStore from "./colegio.store";
import salaStore from "./sala.store";
import _orderBy from "lodash/orderBy";
import { message } from "../helpers/messaging";

const firestore = firebase.firestore();
const collection = "mensajes";
const stateOneName = `${collection}_sel`;
const loadedName = `${collection}_load`;
const stateListName = `${collection}_list`;

const objectConst = {};
objectConst[stateListName] = [];
objectConst[stateOneName] = null;
objectConst[loadedName] = false;

let state = objectConst;

let actions = {
  cleanAllMensaje({ commit }) {
    commit("setState", { key: stateOneName, value: null });
    commit("setState", { key: stateListName, value: [] });
    commit("setState", { key: loadedName, value: false });
  },

  setOneMensaje({ commit, state }, id) {
    if (state.user && state.colegios_sel && state.salas_sel) {
      const finded = state[stateListName].find(sn => sn.id === id);
      if (finded) commit("setState", { key: stateOneName, value: finded });
      return;
    }
    return Promise.reject(
      new Error("User is not logged for set action", collection)
    );
  },

  listMensaje({ commit, state }) {
    if (state.user && state.colegios_sel && state.salas_sel) {
      commit("setState", { key: loadedName, value: true });
      return firestore
        .collection(coleStore.names.collection)
        .doc(state.colegios_sel.id)
        .collection(salaStore.names.collection)
        .doc(state.salas_sel.id)
        .collection(collection)
        .get()
        .then(querysnap => {
          commit("setState", { key: loadedName, value: false });
          const results = [];
          querysnap.forEach(doc => results.push({ id: doc.id, ...doc.data() }));
          commit("setState", { key: stateListName, value: results });
        })
        .catch(err => {
          commit("setState", { key: loadedName, value: false });
          throw err;
        });
    }
    return Promise.reject(
      new Error("User is not logged for list action", collection)
    );
  },

  listMensajeSortedLive({ commit, state, dispatch }) {
    if (state.user && state.colegios_sel && state.salas_sel) {
      const lastDatePulled = JSON.parse(
        localStorage.getItem("lastDateMessage")
      );
      let request = firestore
        .collection(coleStore.names.collection)
        .doc(state.colegios_sel.id)
        .collection(salaStore.names.collection)
        .doc(state.salas_sel.id)
        .collection(collection);
      if (lastDatePulled && lastDatePulled[state.salas_sel.id])
        request = request.where(
          "epoch",
          ">",
          lastDatePulled[state.salas_sel.id]
        );
      return request.onSnapshot(async querysnap => {
        const results = [];
        querysnap.forEach(doc =>
          results.push({
            id: doc.id,
            ...doc.data(),
            salas_id: state.salas_sel.id
          })
        );
        let LastTime = 1;
        for (const result of results) {
          if (LastTime < result.epoch) LastTime = result.epoch;
        }
        const toSaveCache = lastDatePulled || {};
        if (toSaveCache[state.salas_sel.id] === undefined || results.length)
          toSaveCache[state.salas_sel.id] = LastTime;
        localStorage.setItem("lastDateMessage", JSON.stringify(toSaveCache));
        try {
          await idb.MensajesDB().createMany(results);
          const readed = await idb.MensajesDB().read([
            {
              type: "where",
              field: "salas_id",
              op: "===",
              value: state.salas_sel.id
            }
          ]);
          const orderedResults = _orderBy(readed, ["epoch"], ["desc"]);
          const listOfusers = orderedResults.reduce((prev, curr) => {
            prev[curr.creador] = true;
            return prev;
          }, {});
          const users = await Promise.all(
            Object.keys(listOfusers).map(key =>
              dispatch("getUsuarioCloud", key)
            )
          );
          commit("setState", {
            key: stateListName,
            value: orderedResults.map(or => {
              or.user = users.find(ur => ur.id === or.creador);
              return or;
            })
          });
        } catch (error) {
          console.error(error);
        }
      });
    }
  },

  storeMensaje({ commit, state, dispatch }, { data }) {
    if (state.user && state.colegios_sel && state.salas_sel) {
      commit("setState", { key: loadedName, value: true });
      return firestore
        .collection(coleStore.names.collection)
        .doc(state.colegios_sel.id)
        .collection(salaStore.names.collection)
        .doc(state.salas_sel.id)
        .collection(collection)
        .add(data)
        .then(() => {
          message.generateNotification(state.salas_sel.id);
          commit("setState", { key: loadedName, value: false });
          dispatch("updateSala", {
            id: state.salas_sel.id,
            data: {
              ultimo_mensaje: data.mensaje,
              ultimo_remitente: data.creador,
              ultimo_tiempo_remitente: data.epoch,
              mensajes: (state.salas_sel.mensajes || 0) + 1
            }
          });
        })
        .catch(error => {
          commit("setState", { key: loadedName, value: false });
          throw error;
        });
    }
    return Promise.reject(
      new Error("User is not logged for store action", collection)
    );
  },

  updateMensaje({ commit, state }, { id, data }) {
    if (state.user && state.colegios_sel && state.salas_sel) {
      commit("setState", { key: loadedName, value: true });
      return firestore
        .collection(coleStore.names.collection)
        .doc(state.colegios_sel.id)
        .collection(salaStore.names.collection)
        .doc(state.salas_sel.id)
        .collection(collection)
        .doc(id)
        .update(data)
        .then(() => {
          commit("setState", { key: loadedName, value: false });
          const stateCopy = state[stateListName];
          for (let i = 0; i < stateCopy.length; i++) {
            if (stateCopy[i].id === id)
              stateCopy[i] = Object.assign({}, stateCopy[i], data);
          }
          commit("setState", { key: stateListName, value: stateCopy });
        })
        .catch(error => {
          commit("setState", { key: loadedName, value: false });
          throw error;
        });
    }
    return Promise.reject(
      new Error("User is not logged for update action", collection)
    );
  },

  removeMensaje({ commit, state }, { id }) {
    if (state.user && state.colegios_sel && state.salas_sel) {
      commit("setState", { key: loadedName, value: true });
      return firestore
        .collection(coleStore.names.collection)
        .doc(state.colegios_sel.id)
        .collection(salaStore.names.collection)
        .doc(state.salas_sel.id)
        .collection(collection)
        .doc(id)
        .delete()
        .then(() => {
          commit("setState", { key: loadedName, value: false });
          const stateCopy = state[stateListName];
          const index = stateCopy.findIndex(st => st.id === id);
          if (index > -1) stateCopy.splice(index, 1);
          commit("setState", { key: stateListName, value: stateCopy });
        })
        .catch(error => {
          commit("setState", { key: loadedName, value: false });
          throw error;
        });
    }
    return Promise.reject(
      new Error("User is not logged for remove action", collection)
    );
  }
};

export default {
  state,
  actions,
  names: {
    sel: stateOneName,
    list: stateListName,
    load: loadedName
  }
};
